import moment from 'moment';

export function seconds_to_last_duration(value,options={ limit: 2 }) {
  value = Number(value)
  if (isNaN(value) || value < 0) return String(value);
  const duration = moment.duration(value, 'seconds');
  const years = duration.years();
  const months = duration.months();
  const days = duration.days();
  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();
  const parts = [];
  if (years > 0) parts.push(`${years} year${years > 1 ? 's' : ''}`);
  if (months > 0) parts.push(`${months} month${months > 1 ? 's' : ''}`);
  if (days > 0) parts.push(`${days} day${days > 1 ? 's' : ''}`);
  if (hours > 0) parts.push(`${hours} hour${hours > 1 ? 's' : ''}`);
  if (minutes > 0) parts.push(`${minutes} minute${minutes > 1 ? 's' : ''}`);
  if (seconds > 0) parts.push(`${seconds} second${seconds > 1 ? 's' : ''}`);
  if (parts.length==0 && value==0) return '0 seconds';
  if (parts.length==0) return `${value} second${value!=1 ? 's' : ''}`;
  if(options.limit) {
    return parts.slice(0, options.limit).join(' ');
  }
  return parts.join(' ');
}
